import React, { useEffect, useState }  from 'react';
import { SlArrowRight } from 'react-icons/sl';
import '../../../styles/filterStyle.scss'

const FilterBlock = () => {
    const [isOpen, setIsOpen] = useState(false)
    const [listArr, setListArr] = useState([
        {
            img:'image1.svg',
            name:'Divine Anarchy'
        },
        {
            img:'image2.svg',
            name:'Capital Club'
        },
        {
            img:'image3.svg',
            name:'UNIOVERSE'
        },
        {
            img:'image4.svg',
            name:'Champs Only'
        },
        {
            img:'image5.svg',
            name:'Mooncatz'
        },
        {
            img:'image6.svg',
            name:'Cryptelligence'
        },
        {
            img:'image7.svg',
            name:'Roblox'
        },
        {
            img:'image8.svg',
            name:'Kick'
        },
        {
            img:'image8.svg',
            name:'Kick'
        },
        {
            img:'image8.svg',
            name:'Kick'
        },
        {
            img:'image8.svg',
            name:'Kick'
        },

    ])
    return (
        <div className='filter_wrap'>
            <div className='filter_wrap_header'>
                <p>Filter by</p>
                <p>Server:</p>
                <p>All</p>
                <div className='notification_open-drop'>
                    <SlArrowRight
                    className={`close_svg ${isOpen? 'open_svg' : ''}`}
                    onClick={() => setIsOpen(state => !state)}
                    />
                </div>
            </div>
            <div className={`filter_wrap_list ${isOpen? 'open_filter' : ''}`}>
                <div className='list_wrap'>
                    {listArr.map((item, key) => (
                    <div key={key} className='filter_wrap_list_item'>
                        <img src={`./img/filter/${item.img}`} alt="" />
                        <p>{item.name}</p>
                    </div>
                ))}
                </div>               
            </div>
        </div>
    );
};

export default FilterBlock;